import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as history from "app/main/history";

import { columnas } from "./columns";
import { createSelector } from "keautils";
import { Multiselector } from "app/features/componentes/multiselector";

export interface Props {
    /**Folios de las guias seleccionadass¿ */
    value: number[];
    onChange: (value: number[]) => void;
    items: models.PaquetePPCobranzaDto[];
    hideBusqueda?: boolean;
    label?: string;
}


/**Multiselector de las guias, lo unico que muestra es el grid, no muestra los filtros ni ninguna otra cosa  */
export class MultiselectorPaquetePPCobranza extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    items = (props: Props) => props.items;

    onVer = (paquete: models.PaquetePPCobranzaDto) => {
        history.go("/operativa/paquetespp/" + paquete.IdPaquetePP);
    }

    render() {
        const cols = columnas(this);
        return (
            <div>
                {this.props.label && <kea.Title titulo={this.props.label} size="h4" />}
                <Multiselector
                    cookieKey="multiselectorPaquetesCobranza"
                    items={this.items(this.props)}
                    columnas={cols}
                    hideBusqueda={this.props.hideBusqueda}
                    value={this.props.value}
                    onChange={this.props.onChange}
                    getKey={x => x.IdPaquetePP}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cobranza/contrarecibos/modales/generarcontrarecibospp/paquetespp/index.tsx